import Avatar from '@components/v2/ui/Avatar/Avatar';
import IconButton from '@components/v2/ui/IconButton/IconButton';
import { Box, Fade, LinearProgress } from '@mui/material';
import { Camera } from 'lucide-react';
import { useRef } from 'react';
import LangEnum from '../lang/LangEnum';
import { useTranslation } from '../modules/translation/TranslationContext';

const AVATAR_SIZE = 152;

type AvatarUploadProps = {
  alt: LangEnum;
  proccessFile: (file: File) => void;
  imageUrl?: string;
  isLoading?: boolean;
};

const AvatarUpload = ({ alt, imageUrl, isLoading, proccessFile }: AvatarUploadProps) => {
  const { translate } = useTranslation();
  const inputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (files: FileList | null) => {
    if (files?.[0]) {
      proccessFile(files[0]);
    }
  };

  return (
    <Box sx={{ display: 'inline-block', width: AVATAR_SIZE }}>
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <Avatar size={AVATAR_SIZE} src={imageUrl} alt={translate(alt)} fallback="icon" />

        <input
          hidden
          ref={inputRef}
          type="file"
          accept="image/*"
          onChange={(event) => {
            handleFileChange(event.target.files);
            event.target.value = '';
          }}
        />

        <Box sx={{ position: 'absolute', right: 0, bottom: 0 }}>
          <IconButton
            icon={Camera}
            size="large"
            color="secondary"
            ariaLabel={translate(LangEnum.GLOBAL_ADD_PHOTO)}
            disabled={isLoading}
            onClick={() => inputRef.current?.click()}
          />
        </Box>
      </Box>

      <Fade in={isLoading}>
        <LinearProgress />
      </Fade>
    </Box>
  );
};

export default AvatarUpload;
